import { setProductMasters, setTotal, setProductMasterColumn } from '../redux/slices/productMasterSlice';

export const fetchProductMaster = async (dispatch, accessToken, customParams = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(customParams).filter(([key, value]) => value !== '')
    );

    const queryString = Object.keys(filteredParams)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filteredParams[key])}`)
      .join('&');

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/product-master`;
    const fullUrl = queryString ? `${apiUrl}?${queryString}` : apiUrl;

    const response = await fetch(fullUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      dispatch(setProductMasters(data.data));
      dispatch(setTotal(data.pagination_info.total));
    } else {
      dispatch(setProductMasters([]));
      console.error(`Failed to fetch product masters:`, response.statusText);
    }
  } catch (error) {
    console.error(`Error fetching product masters:`, error);
  }
};

export const fetchProductPhoto = async (accessToken, surveyId, productCode, page, limit, sortBy, sortOrder) => {
 try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/project-assets?survey_id=${surveyId}&product_code=${productCode}&page=${page}&limit=${limit}&asset_type=image_product&order_by=${sortBy}&order_dir=${sortOrder}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) return null;

    const res = await response.json();
    const { data, total, page: p, limit: l } = res;

    const imageUrls = (data || []).map((item) => ({
      id: item.id,
      file: `${process.env.REACT_APP_API_URL}/api/v1/project-assets/${item.id}/view`,
      createdAt: item.created_at,
      storeCode: item.store_code,
    }));

    return {
      items: imageUrls,
      total,
      page: p,
      limit: l,
    };
  } catch (err) {
    console.error(err);
    return null;
  }
}

export const fetchProductMasterColumn = async (dispatch, accessToken, customParams = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(customParams).filter(([key, value]) => value !== '')
    );

    const queryString = Object.keys(filteredParams)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filteredParams[key])}`)
      .join('&');

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/product-master-columns`;
    const fullUrl = queryString ? `${apiUrl}?${queryString}` : apiUrl;

    const response = await fetch(fullUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      dispatch(setProductMasterColumn(data.data));
    } else {
      dispatch(setProductMasterColumn([]));
      console.error(`Failed to fetch product master column:`, response.statusText);
    }
  } catch (error) {
    console.error(`Error fetching product master column:`, error);
  }
};

export const exportproductmastersetup = async (accessToken, title, url, customParams = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(customParams).filter(([key, value]) => value !== '')
    );

    const queryString = Object.keys(filteredParams)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filteredParams[key])}`)
      .join('&');

    const apiUrl = `${process.env.REACT_APP_API_URL}/${url}`;
    const fullUrl = queryString ? `${apiUrl}?${queryString}` : apiUrl;
    
    const response = await fetch(fullUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.ok) {
      const blob = await response.blob();
      return blob;
    } else {
      console.error(`Failed to export ${title} product:`, response.statusText);
      return;
    }
  } catch (error) {
    console.error(`Error exporting ${title} product:`, error);
  }
};
